'use strict';

var dialog = require('./dialog');
var util = require('./util');
/**
 * @function getConsent Used to display/control of the modal containing the consent management message
 **/

// Canadian Provinces Mapping

function getProvinceMappings(consentRequiredStates) {
    var mappings = JSON.parse(consentRequiredStates);
    var provinceStateMap = {};

    mappings.forEach(function (entry) {
        var countryCode = entry.countryCode;
        provinceStateMap[countryCode] = {}; // Initialize country mapping

        entry.states.forEach(function (stateObj) {
            var stateCode = Object.keys(stateObj)[0]; // Extract state short code (e.g., "CA")
			var lowerCaseStateCode = stateCode.toLowerCase().replace(/\s+/g, ''); // Remove spaces for consistency
            provinceStateMap[countryCode][lowerCaseStateCode] = stateCode; // Map lowercase full name → short code
        });
    });
    return provinceStateMap;
}

function isConsentCookieBannerBasedOnRegion(currentStateCode, currentCountryCode, consentRequiredStates) {
    if (!currentStateCode || !currentCountryCode || !consentRequiredStates) {
        return false;
    }
    var mappings = getProvinceMappings(consentRequiredStates);
    if (!mappings[currentCountryCode]) {
        return false;
    }
    var formattedStateCode = currentStateCode.toLowerCase().replace(/\s+/g, '');
	if (!mappings[currentCountryCode][formattedStateCode]) {
        return false;
    }
    return mappings[currentCountryCode][formattedStateCode];
}

function getConsent() {
    // Check if consent cookie already exists
    if (document.cookie.includes("sl_custom_consent_accepted=")) {
        return; // Exit early if user has already responded to consent
    }
    if (document.cookie.includes("sl_custom_consent_rejected=")) {
        return; // Exit early if user has already responded to consent
    }
    //Based displayCookieBannerBasedOnRegion flag need to display the cookie banner
    const displayCookieBannerBasedOnRegion = window.SitePreferences ? SitePreferences.DISPLAY_COOKIE_BANNER_BASED_ON_REGION :false;
    if (displayCookieBannerBasedOnRegion) {
        const stateInput = document.getElementById("currentGeoState");
        const countryInput = document.getElementById("currentGeoCountry"); // Add this in your HTML
        const currentStateCode = stateInput ? stateInput.value : null;
        const currentCountryCode = countryInput ? countryInput.value : null;

        const consentRequiredStates = window.SitePreferences ? SitePreferences.CONSENT_TRACKING_REQUIRED_STATES_LIST : [];

        if (!isConsentCookieBannerBasedOnRegion(currentStateCode, currentCountryCode, consentRequiredStates)) {
            return;
        }
    }
    $.ajax({
        url: Urls.consentTracking,
        type: 'GET',
        data: { aid: 'consent_tracking_cookie_banner' },
        success: function (data) {
            let consentHTML = $(data).find('.content-asset').html();
            if (consentHTML) {
                let consentBanner = document.createElement("div");
                consentBanner.id = "cookieConsentBanner";
                consentBanner.innerHTML = consentHTML;
                document.body.appendChild(consentBanner);

                // Slight delay to allow transition
                setTimeout(function () {
                    consentBanner.classList.add("show");
                }, 20);

                document.getElementById("acceptCookiesBtn").addEventListener("click", function () {
                    $.ajax({
                        type: 'GET',
                        url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', true),
                        success: function () {
                            consentBanner.remove(); // Hide and remove from DOM

                            const CONSENT_TRACKING_AGE_IN_SECONDS = window.SitePreferences ? (SitePreferences.CONSENT_TRACK_COOKIE_AGE_IN_DAYS * 24 * 60 * 60) : (90 * 24 * 60 * 60); // fallback 90 days
                            document.cookie = `sl_custom_consent_accepted=1; Secure; path=/; max-age=${CONSENT_TRACKING_AGE_IN_SECONDS};`;
                            document.cookie = "dw_dnt=0; Secure;";
                            document.cookie = "__cq_dnt=0; Secure;";
                        }
                    });
                });

                document.getElementById("closeConsentBanner").addEventListener("click", function () {
                    $.ajax({
                        type: 'GET',
                        url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', false),
                        success: function () {
                            consentBanner.remove();
                            const CONSENT_TRACKING_AGE_IN_SECONDS = window.SitePreferences ? (SitePreferences.CONSENT_TRACK_COOKIE_AGE_IN_DAYS * 24 * 60 * 60) : (90 * 24 * 60 * 60); // fallback 90 days
                            document.cookie = `sl_custom_consent_accepted=0; Secure; path=/; max-age=${CONSENT_TRACKING_AGE_IN_SECONDS};`;
                            document.cookie = "dw_dnt=1; Secure;";
                            document.cookie = "__cq_dnt=1; Secure;";
                        }
                    });
                });

                document.getElementById("cookieCloseIcon").addEventListener("click", function () {
                    consentBanner.remove();
                    const CONSENT_TRACKING_POPUP_AGE_IN_SECONDS = window.SitePreferences ? (SitePreferences.CONSENT_TRACKING_POPUP_AGE_IN_DAYS * 24 * 60 * 60) : (90 * 24 * 60 * 60); // fallback 90 days
                    document.cookie = `sl_custom_consent_rejected=0; Secure; path=/; max-age=${CONSENT_TRACKING_POPUP_AGE_IN_SECONDS };`;
                    document.cookie = "dw_dnt=1; Secure;";
                    document.cookie = "__cq_dnt=1; Secure;";
                });
            }
        },
        error: function () {
            console.error("Failed to load cookie consent content asset.");
        }
    });
}


function enablePrivacyCookies() {
    if (document.cookie.indexOf('dw=1') < 0) {
        document.cookie = 'dw=1; Secure; path=/';
    }
    if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
        document.cookie = 'dw_cookies_accepted=1; Secure; path=/';
    }
}
function showPrivacyDialog(){

    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            dialog.open({
                url: Urls.cookieHint,
                options: {
                    closeOnEscape: false,
                    dialogClass: 'no-close',
                    buttons: [{
                        text: Resources.I_AGREE,
                        click: function () {
                            $(this).dialog('close');
                            enablePrivacyCookies();
                        }
                    }]
                }
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enablePrivacyCookies();
    }
}
var consentTracking = {
    init: function () {
        if (consent == null && SitePreferences.CONSENT_TRACKING_HINT && SitePreferences.CONSENT_TRACK_COOKIE_ENABLED) { // eslint-disable-line no-undef
            getConsent();
        }
    },
    show: function () {
        if (consent == null && SitePreferences.CONSENT_TRACKING_HINT && SitePreferences.CONSENT_TRACK_COOKIE_ENABLED) { // eslint-disable-line no-undef
            getConsent();
        }
    }
};

(function() {
    var cookies = document.cookie.split(';').reduce((acc, cookie) => {
        const [name, value] = cookie.trim().split('=');
        acc[name] = value;
        return acc;
    }, {});

    var consentAccepted = cookies['sl_custom_consent_accepted'];
    const CONSENT_TRACKING_AGE_IN_SECONDS = window.SitePreferences ? (SitePreferences.CONSENT_TRACK_COOKIE_AGE_IN_DAYS * 24 * 60 * 60) : (90 * 24 * 60 * 60); // fallback 90 days
    if (typeof consentAccepted !== 'undefined' && !consentAccepted) {
        document.cookie = `sl_custom_consent_accepted=0; Secure; path=/; max-age=${CONSENT_TRACKING_AGE_IN_SECONDS};`;
        document.cookie = "dw_dnt=1; Secure;";
        document.cookie = "__cq_dnt=1; Secure;";
    } else if (consentAccepted === '1') {
        // Set both dw_dnt and __cq_dnt cookies
        if(cookies['dw_dnt'] == '1' || cookies['__cq_dnt'] == '1'){
            document.cookie = "dw_dnt=0; Secure;";
            document.cookie = "__cq_dnt=0; Secure;";
        }
    } else if(consentAccepted === '0'){
        // Set both dw_dnt and __cq_dnt cookies
        document.cookie = "dw_dnt=1; Secure;";
        document.cookie = "__cq_dnt=1; Secure;";
    }
})();

module.exports = consentTracking;
